import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import queryString from 'query-string';

import { accountService, alertService } from '../_services';
import { useTranslation } from 'react-i18next';

function VerifyEmail({ history }) {
    const { t } = useTranslation();
    const EmailStatus = {
        Verifying: 'Verifying',
        Failed: 'Failed'
    }

    const [emailStatus, setEmailStatus] = useState(EmailStatus.Verifying);

    useEffect(() => {
        const { token } = queryString.parse(window.location.search);

        // remove token from url to prevent http referer leakage
        history.replace(window.location.pathname);

        accountService.verifyEmail(token)
            .then(() => {
                alertService.success( t('verify.success') , { keepAfterRouteChange: true });
                history.push('login');
            })
            .catch(() => {
                setEmailStatus(EmailStatus.Failed);
            });
    }, []);

    function getBody() {
        switch (emailStatus) {
            case EmailStatus.Verifying:
                return <div>Verifying...</div>;
            case EmailStatus.Failed:
                return <div>{t('verify.fail')}<Link to="forgot-password">{t('Forgot Password')}</Link> page.</div>;
        }
    }

    return (
        <div>
            <h3 className="card-header">{t('Verify Email')}</h3>
            <div className="card-body">{getBody()}</div>
        </div>
    )
}

export { VerifyEmail }; 